import { SxProps, Theme } from "@mui/material";
import * as Yup from "yup";
import { createMapper } from "../utils/utils";
import { Option } from "./common";

export const INSTANT_APPOINTMENT_VALIDATION_SCHEMA = Yup.object({
  patient: Yup.object().required().label("Patient"),
  provider: Yup.object().required().label("Provider"),
  note: Yup.string(),
  rescheduleReason: Yup.string().required().label("Chief Complaint"),
});

export const NEW_APPOINTMENT_TYPE: Option[] = [
  {
    value: "FOLLOWUP",
    label: "Follow-Up Visit",
  },
  {
    value: "ADMINISTRATIVE",
    label: "Administrative",
  },
  {
    value: "CARE_COORDINATION",
    label: "Care Coordination",
  },
  {
    value: "MEDICATION_BRIEF",
    label: "Medication Brief",
  },
  {
    value: "NEW",
    label: "New Patient Visit",
  },
  {
    value: "NURSING_ONLY",
    label: "Nursing Only",
  },
  {
    value: "TELEPHONE_CALL",
    label: "Telephone Call",
  },
  {
    value: "URGENT_VISIT",
    label: "Urgent Visit",
  },
  {
    value: "VIDEO_VISIT",
    label: "Video Visit",
  },
  {
    value: "WELLNESS_EXAM",
    label: "Wellness Exam",
  },
];

export const NEW_APPOINTMENT_VISIT_TYPE: Option[] = [
  {
    value: "IN_PERSON",
    label: "In Person",
  },
  {
    value: "VIRTUAL",
    label: "Telehealth",
  },
];

export const NEW_APPOINTMENT_VISIT_TYPE_MAPPER = createMapper(
  NEW_APPOINTMENT_VISIT_TYPE
);

export const NEW_APPOINTMENT_INSURANCE_TYPE: Option[] = [
  {
    value: "INSURANCE",
    label: "Insurance",
  },
  {
    value: "ONLINE",
    label: "Self Pay",
  },
];

export const TIME_OPTIONS = [
  { value: "00:00:00", label: "12:00 AM" },
  { value: "00:15:00", label: "12:15 AM" },
  { value: "00:30:00", label: "12:30 AM" },
  { value: "00:45:00", label: "12:45 AM" },
  { value: "01:00:00", label: "01:00 AM" },
  { value: "01:15:00", label: "01:15 AM" },
  { value: "01:30:00", label: "01:30 AM" },
  { value: "01:45:00", label: "01:45 AM" },
  { value: "02:00:00", label: "02:00 AM" },
  { value: "02:15:00", label: "02:15 AM" },
  { value: "02:30:00", label: "02:30 AM" },
  { value: "02:45:00", label: "02:45 AM" },
  { value: "03:00:00", label: "03:00 AM" },
  { value: "03:15:00", label: "03:15 AM" },
  { value: "03:30:00", label: "03:30 AM" },
  { value: "03:45:00", label: "03:45 AM" },
  { value: "04:00:00", label: "04:00 AM" },
  { value: "04:15:00", label: "04:15 AM" },
  { value: "04:30:00", label: "04:30 AM" },
  { value: "04:45:00", label: "04:45 AM" },
  { value: "05:00:00", label: "05:00 AM" },
  { value: "05:15:00", label: "05:15 AM" },
  { value: "05:30:00", label: "05:30 AM" },
  { value: "05:45:00", label: "05:45 AM" },
  { value: "06:00:00", label: "06:00 AM" },
  { value: "06:15:00", label: "06:15 AM" },
  { value: "06:30:00", label: "06:30 AM" },
  { value: "06:45:00", label: "06:45 AM" },
  { value: "07:00:00", label: "07:00 AM" },
  { value: "07:15:00", label: "07:15 AM" },
  { value: "07:30:00", label: "07:30 AM" },
  { value: "07:45:00", label: "07:45 AM" },
  { value: "08:00:00", label: "08:00 AM" },
  { value: "08:15:00", label: "08:15 AM" },
  { value: "08:30:00", label: "08:30 AM" },
  { value: "08:45:00", label: "08:45 AM" },
  { value: "09:00:00", label: "09:00 AM" },
  { value: "09:15:00", label: "09:15 AM" },
  { value: "09:30:00", label: "09:30 AM" },
  { value: "09:45:00", label: "09:45 AM" },
  { value: "10:00:00", label: "10:00 AM" },
  { value: "10:15:00", label: "10:15 AM" },
  { value: "10:30:00", label: "10:30 AM" },
  { value: "10:45:00", label: "10:45 AM" },
  { value: "11:00:00", label: "11:00 AM" },
  { value: "11:15:00", label: "11:15 AM" },
  { value: "11:30:00", label: "11:30 AM" },
  { value: "11:45:00", label: "11:45 AM" },
  { value: "12:00:00", label: "12:00 PM" },
  { value: "12:15:00", label: "12:15 PM" },
  { value: "12:30:00", label: "12:30 PM" },
  { value: "12:45:00", label: "12:45 PM" },
  { value: "13:00:00", label: "01:00 PM" },
  { value: "13:15:00", label: "01:15 PM" },
  { value: "13:30:00", label: "01:30 PM" },
  { value: "13:45:00", label: "01:45 PM" },
  { value: "14:00:00", label: "02:00 PM" },
  { value: "14:15:00", label: "02:15 PM" },
  { value: "14:30:00", label: "02:30 PM" },
  { value: "14:45:00", label: "02:45 PM" },
  { value: "15:00:00", label: "03:00 PM" },
  { value: "15:15:00", label: "03:15 PM" },
  { value: "15:30:00", label: "03:30 PM" },
  { value: "15:45:00", label: "03:45 PM" },
  { value: "16:00:00", label: "04:00 PM" },
  { value: "16:15:00", label: "04:15 PM" },
  { value: "16:30:00", label: "04:30 PM" },
  { value: "16:45:00", label: "04:45 PM" },
  { value: "17:00:00", label: "05:00 PM" },
  { value: "17:15:00", label: "05:15 PM" },
  { value: "17:30:00", label: "05:30 PM" },
  { value: "17:45:00", label: "05:45 PM" },
  { value: "18:00:00", label: "06:00 PM" },
  { value: "18:15:00", label: "06:15 PM" },
  { value: "18:30:00", label: "06:30 PM" },
  { value: "18:45:00", label: "06:45 PM" },
  { value: "19:00:00", label: "07:00 PM" },
  { value: "19:15:00", label: "07:15 PM" },
  { value: "19:30:00", label: "07:30 PM" },
  { value: "19:45:00", label: "07:45 PM" },
  { value: "20:00:00", label: "08:00 PM" },
  { value: "20:15:00", label: "08:15 PM" },
  { value: "20:30:00", label: "08:30 PM" },
  { value: "20:45:00", label: "08:45 PM" },
  { value: "21:00:00", label: "09:00 PM" },
  { value: "21:15:00", label: "09:15 PM" },
  { value: "21:30:00", label: "09:30 PM" },
  { value: "21:45:00", label: "09:45 PM" },
  { value: "22:00:00", label: "10:00 PM" },
  { value: "22:15:00", label: "10:15 PM" },
  { value: "22:30:00", label: "10:30 PM" },
  { value: "22:45:00", label: "10:45 PM" },
  { value: "23:00:00", label: "11:00 PM" },
  { value: "23:15:00", label: "11:15 PM" },
  { value: "23:30:00", label: "11:30 PM" },
  { value: "23:45:00", label: "11:45 PM" },
];

type PaymentMode = "INSURANCE" | "CASH";

export const NEW_PATIENT_APPOINTMENT_SCHEMA = Yup.object({
  // patientId: Yup.object().required().label("Patient Name"),
  timezone: Yup.object().required().label("Timezone"),
  type: Yup.mixed().required().label("Appointment Type"),
  mode: Yup.string(),
  duration: Yup.string().trim().required("Please Select Slot"),
  chiefComplaint: Yup.string().trim().required().label("Chief Complaint"),
  paymentType: Yup.string().nullable(),
  providerId: Yup.object().required().label("Provider"),
  primary_insurance: Yup.object({ uuid: Yup.string() }).nullable(),
  secondary_insurance: Yup.object({
    uuid: Yup.string()
      .nullable()
      .test(
        "not-same-as-primary",
        "Primary and Secondary insurance cannot be the same",
        function (value, { options }) {
          const primaryUuid = options?.context?.primary_insurance?.uuid;

          // skip validation for paymentMode is not INS
          if ((options?.context?.paymentType as PaymentMode) !== "INSURANCE")
            return true;

          if (!primaryUuid || !value) return true; // skip if either is null/undefined
          return value !== primaryUuid;
        }
      ),
  }),
});

/* Reschedule holds the appointment as plain ids, not the option objects
   NEW_APPOINTMENT_SCHEMA expects, so it validates only what that screen edits. */
export const RESCHEDULE_APPOINTMENT_SCHEMA = Yup.object({
  chiefComplaint: Yup.string().trim().required().label("Chief Complaint"),
});

export const NEW_APPOINTMENT_SCHEMA = Yup.object({
  patientId: Yup.object().required().label("Patient Name"),
  timezone: Yup.object().required().label("Timezone"),
  type: Yup.mixed().required().label("Appointment Type"),
  mode: Yup.string(),
  // Location is mandatory for In-Person (slots are location-specific) and
  // optional for Telehealth. Mixed, not string: the field holds the
  // AsyncSelect option object.
  locationId: Yup.mixed().when("mode", {
    is: (mode: string) => mode === "IN_PERSON",
    then: (schema) => schema?.required().label("Location"),
    otherwise: (schema) => schema?.notRequired(),
  }),
  duration: Yup.string().trim().required("Please Select Slot"),
  chiefComplaint: Yup.string().trim().required().label("Chief Complaint"),
  paymentType: Yup.string().nullable(),
  providerId: Yup.object().required().label("Provider"),
  primary_insurance: Yup.object({ uuid: Yup.string() }).nullable(),
  secondary_insurance: Yup.object({
    uuid: Yup.string()
      .nullable()
      .test(
        "not-same-as-primary",
        "Primary and Secondary insurance cannot be the same",
        function (value, { options }) {
          const primaryUuid = options?.context?.primary_insurance?.uuid;

          // skip validation for paymentMode is not INS
          if ((options?.context?.paymentType as PaymentMode) !== "INSURANCE")
            return true;

          if (!primaryUuid || !value) return true; // skip if either is null/undefined
          return value !== primaryUuid;
        }
      ),
  }),
  reminder_set: Yup.boolean().nullable().default(false),
  isRecurring: Yup.boolean().nullable().default(false),
  /* Recurring appointment validation is commented out along with the Recurring
     control on the appointment form. Every rule below already resolved to
     notRequired (the $isRecurring context is never supplied), so removing them
     does not change what the form accepts. `isRecurring` above keeps its
     boolean default so the submitted payload shape is unchanged.
     https://medarch.atlassian.net/browse/ECRH-6020 */
  // recurringFrequency: Yup.string().when("$isRecurring", {
  //   is: true,
  //   then: (schema) => schema?.required().label("Recurring Frequency"),
  //   otherwise: (schema) => schema?.notRequired(),
  // }),

  // endType: Yup.string().when("$isRecurring", {
  //   is: true,
  //   then: (schema) => schema?.required().label("End Type"),
  //   otherwise: (schema) => schema?.notRequired(),
  // }),
  // endDate: Yup.date().when(["$isRecurring", "$endType"], {
  //   is: (isRecurring: boolean, endType: string) =>
  //     isRecurring && endType === "on_date",
  //   then: (schema) => schema.required().label("End Date"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  // endAfter: Yup.number().when("$isRecurring", {
  //   is: true,
  //   then: (schema) => schema?.required().label("End After"),
  //   otherwise: (schema) => schema?.notRequired(),
  // }),

  // customFrequency: Yup.number().when("$isRecurring", {
  //   is: true,
  //   then: (schema) => schema?.required().label("Repeat Every"),
  //   otherwise: (schema) => schema?.notRequired(),
  // }),
  // customFrequencyUnit: Yup.string().when("$isRecurring", {
  //   is: true,
  //   then: (schema) => schema?.required().label("Repeat Every Unit"),
  //   otherwise: (schema) => schema?.notRequired(),
  // }),
  // selectedWeekdays: Yup.array().when("$isRecurring", {
  //   is: true,
  //   then: (schema) => schema?.required().label("Selected Weekdays"),
  //   otherwise: (schema) => schema?.notRequired(),
  // }),

  reminders: Yup.object({
    reminderBeforeNumber: Yup.number().when("$reminder_set", {
      is: true,
      then: (schema) => schema?.required().label("Remind Before"),
      otherwise: (schema) => schema?.notRequired(),
    }),
    reminderBeforeUnit: Yup.string().when("$reminder_set", {
      is: true,
      then: (schema) => schema?.required().label("Remind Before Unit"),
      otherwise: (schema) => schema?.notRequired(),
    }),
    reminderMedium: Yup.array()
      .of(Yup.string())
      .when("$reminder_set", {
        is: true,
        then: (schema) => schema?.required().min(1).label("Remind Medium"),
        otherwise: (schema) => schema?.notRequired(),
      }),
  }),
  // dateAndTime: Yup.string().when("endTime", {
  //   is: (date: string) => !!date,
  //   then: (schema) => schema?.notRequired(),
  //   otherwise: (schema) => schema?.required().label("Date & Time"),
  // }),

  // visit_type: Yup.string(),
  // appointment_type: Yup.string(),
  // location: Yup.string(),
  // specialities: Yup.string(),
  // provider: Yup.string(),
  // date_and_time: Yup.string(),
  // room: Yup.string(),
  // insurance_type: Yup.string(),
  // reason_for_appointment: Yup.string(),
  // patient_appointment_note: Yup.string(),
  // primary_insurance: Yup.string(),
  // secondary_insurance: Yup.string(),
  // authorization: Yup.string(),
  // forms: Yup.array().of(Yup.string()),
});

export type NewPatientType = {
  firstName: string;
  middle_name: string;
  lastName: string;
  birthDate: string;
  gender: string;
  email?: string;
  mobileNumber: string;
  timezone: string;
};

export const NEW_PATIENT_INITIAL_VALUES: NewPatientType = {
  firstName: "",
  middle_name: "",
  lastName: "",
  birthDate: "",
  gender: "",
  email: undefined,
  mobileNumber: "",
  timezone: "IST",
};

export const NEW_PATIENT_VALIDATION_SCHEMA = Yup.object({
  firstName: Yup.string().required().label("First Name"),
  middle_name: Yup.string().optional(),
  lastName: Yup.string().required().label("Last Name"),
  birthDate: Yup.string().required().label("Date of Birth"),
  gender: Yup.string().required().label("Gender"),
  email: Yup.string()
    .email()
    .matches(/.*@.+\..+/, "Email address must be a valid Email"),
  // .required()
  // .label("Email"),
  mobileNumber: Yup.string().optional(),
});

/** A locked date/time picker that holds a value shows it in body text, not the greyed placeholder colour. */
export const FILLED_LOCKED_PICKER_SX: SxProps<Theme> = {
  "& .MuiPickersInputBase-root.Mui-disabled": { color: "text.primary" },
};
